import * as React from "react";
import ReactDOM from "react-dom";

import { AutocompleteSearch} from './shop/autocomplete-search/';

function factory() {
  function init(suggestionTypes) {
    const containers = [...document.querySelectorAll('[data-jsx="autocomplete-search"]')];

    if (!containers.length > 0) return;

    containers.forEach(container => {
      const {
        autocompleteUrl,
        formAction,
        minCharCount,
        placeholder,
        defaultValue,
        languageCode
      } = container.dataset;

      const element = React.createElement(AutocompleteSearch, { autocompleteUrl, formAction, minCharCount, placeholder, defaultValue, suggestionTypes, languageCode });

      ReactDOM.render(element, container);
    })
  }

  return {
    init
  }
}

const autocompleteSearch = factory();
export { autocompleteSearch as AutocompleteSearch };
